export const goBackActionText = 'Вернуться назад';
